module.exports = __webpack_public_path__ + "img/en_tis_uninstall1.d467bc15.png";